module.exports = __webpack_public_path__ + "img/classic_gold_print.234a2fc9.png";